import { Config } from '../types';
import contracts from './contracts';
import keys from './keys';
import pools from './pools';
import rateProviders from './rateProviders';
import tokenlists from './tokenlists';
import tokens from './tokens';

const config: Config = {
  key: '80069',
  chainId: 80069,
  chainName: 'Bepolia',
  name: 'Bepolia',
  shortName: 'Bepolia',
  monorepoName: 'Bepolia',
  slug: 'bepolia',
  network: 'bepolia',
  trustWalletNetwork: 'bepolia',
  unknown: false,
  visibleInUI: true,
  testNetwork: true,
  publicRpc: `https://bepolia.rpc.berachain.com`,
  rpc: `https://bepolia.rpc.berachain.com`,
  ws: ``,
  explorer: 'https://bepolia.beratrail.io',
  explorerName: 'Beratrail',
  subgraph:
    'https://api.goldsky.com/api/public/project_cluukfpdrw61a01xag6yihcuy/subgraphs/bepolia/0.0.1/gn',
  poolsUrlV2:
    'https://storageapi.fleek.co/johngrantuk-team-bucket/poolsV2.json',
  subgraphs: {
    main: [
      'https://api.goldsky.com/api/public/project_cluukfpdrw61a01xag6yihcuy/subgraphs/bepolia/0.0.1/gn',
    ],
    aave: '',
    gauge: '',
    blocks: '',
    ammRewards:
      'https://api.goldsky.com/api/public/project_cluukfpdrw61a01xag6yihcuy/subgraphs/bepolia-burr-rewards-subgraph/0.0.1/gn',
  },
  bridgeUrl: '',
  supportsEIP1559: true,
  supportsElementPools: false, // hides featured ecosystems section under pool list
  blockTime: 12,
  nativeAsset: {
    name: 'BERA',
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'BERA',
    decimals: 18,
    deeplinkId: 'bera',
    logoURI: 'tokens/eth.png',
    minTransactionBuffer: '0.05',
  },
  thirdParty: {
    coingecko: {
      nativeAssetId: 'bepolia',
      platformId: 'bepolia',
    },
    apyVision: {
      networkName: '',
    },
  },
  addresses: {
    ...contracts,
  },
  pools,
  tokens,
  keys,
  gauges: {
    type: 2,
    weight: 100,
  },
  tokenlists,
  rateProviders,
};

export default config;
